import HotelThumbnail from './HotelThumbnail.component';
export default HotelThumbnail;